import React, { useContext, useEffect, useRef, useState } from "react";
import "../../../../../styles/workspace_styles/TenantAdministratorStyles/Devices/Device/Device.css";
import { LoadShortDate } from "../../../../../functions/LoadShortDate.js";
import { LoadShortTime } from "../../../../../functions/LoadShortTime.js";
import {thingsBoardMicroserviceUrl} from "../../../../../microservices/thingsboard_microservice.js";
import ConfigurationExplorer from "../ConfigurationExplorer.jsx";
import NewConfiguration from "../NewConfiguration.jsx";
import ImportConfiguration from "../ImportConfiguration.jsx";
import { DeviceContext } from "../DeviceProvider.jsx";
import BillingDetails from "./BillingDetails.jsx";
const DeviceConfigurationYesNoMessageBox = ({showDeviceConfigurationYesNoMessageBox,setShowDeviceConfigurationMessageBox,title,question,setDialogResult}) =>{
    if(!showDeviceConfigurationYesNoMessageBox) return null;
    return(
        <div className="device-configuration-yes-no-message-box-container">
            <div className="device-configuration-yes-no-message-box-title-container">
                <p>{title}</p>
                <p
                    style={{cursor:'pointer'}}
                    onClick={() => setShowDeviceConfigurationMessageBox(false)}>&#10006;</p>
            </div>
            <div className="device-configuration-yes-no-message-box-question-container">
                <p>
                    {question.split('\n').map((line, index) => (
                        <span key={index}>
                            {line}
                            {index < question.split('\n').length - 1 && <br />}
                        </span>
                    ))}
                </p>
            </div>
            <div className="device-configuration-yes-no-message-box-buttons-container">
                <button onClick={() => {
                    setDialogResult(false);
                    setShowDeviceConfigurationMessageBox(false);
                }}>No</button>
                <button onClick={() => {
                    setDialogResult(true);
                    setShowDeviceConfigurationMessageBox(false);
                }}>Yes</button>
            </div>
        </div>
    );
}
const DeviceConfigurationMessageBox = ({showDeviceConfigurationMessageBox,setShowDeviceConfigurationMessageBox,title,message}) =>{
    if(!showDeviceConfigurationMessageBox) return null;
    return(
        <div className="device-configuration-message-box-container">
            <div className="device-configuration-message-box-title-container">
                <p>{title}</p>
                <p
                    style={{cursor:'pointer'}}
                    onClick={() => setShowDeviceConfigurationMessageBox(false)}>
                        &#10006;
                </p>
            </div>
            <div className="device-configuration-message-box-message-container">
                <p style={{marginTop:'30px'}}>{message}</p>
            </div>
            <div className="device-configuration-message-box-buttons-container">
                <button onClick={() => setShowDeviceConfigurationMessageBox(false)}>Ok</button>
            </div>
        </div>
    );
}
const Details = ({device,showDeviceDetails,setShowBottomRightMessageBox,setBottomRightMessageBoxMessage}) =>{
    if(!device || !showDeviceDetails) return null;
    return (
        <div className="device-details-container">
            <div className="device-details-header">
                <button onClick={() => {
                    if(navigator.clipboard) {
                        navigator.clipboard.writeText(device.id);
                        setBottomRightMessageBoxMessage('Device Id has been copied to clipboard');
                        setShowBottomRightMessageBox(true);
                    }
                    else{
                        alert(device.id);
                    }}}>Copy device id</button>
                <button onClick={() => {
                    if(navigator.clipboard) {
                        navigator.clipboard.writeText(device.accessToken);
                        setBottomRightMessageBoxMessage('Device access token has been copied to clipboard');
                        setShowBottomRightMessageBox(true);
                    }
                    else{
                        alert(device.accessToken);
                    }}}>Copy access token</button>
                <button>Delete device</button>
            </div>
            <div>
                <div className="device-details-property-container">
                    <p>Name</p>
                    <input disabled value={device.name?device.name:''}/>
                </div>
                <div className="device-details-property-container">
                    <p>Label</p>
                    <input disabled value={device.label?device.label:''}/>
                </div>
                <div className="device-details-property-container">
                    <p>Description</p>
                    <input disabled value={device.description?device.description:''} />
                </div>
                <div className="device-details-property-container">
                    <p>Customer name</p>
                    <input disabled value={device?.customer?.external?.name||''} />
                </div>
            </div>
        </div>
    );
};
const ServerAttributes = ({device,showServerAttributes}) =>{
    function getServerAttributValue(serverAttribute){
        switch(serverAttribute.value){
            case true: return 'true';
            case false: return 'false';
            default: return serverAttribute.value;
        }
    }
    if(!device ||!device.serverAttributes == null || !showServerAttributes) return null;
    return(
        <div className="attributes-table-container">
            <table className="attributes-table">
                <thead>
                    <tr id="attributes-table-header-row">
                        <th>Last update date</th>
                        <th>Last update time</th>
                        <th>Key</th>
                        <th>Value</th>
                    </tr>
                </thead>
                <tbody>
                    {device.serverAttributes.map(serverAttribute => (
                        <tr key={serverAttribute.key}>
                            <td>{LoadShortDate(serverAttribute.lastUpdateTs)}</td>
                            <td>{LoadShortTime(serverAttribute.lastUpdateTs)}</td>
                            <td>{serverAttribute.key}</td>
                            <td>{getServerAttributValue(serverAttribute)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
const SharedAttributes = ({device,showSharedAttributes}) =>{
    function getSharedAttributValue(sharedAttribute){
        switch(sharedAttribute.value){
            case true: return 'true';
            case false: return 'false';
            default: return sharedAttribute.value;
        }
    }
    if(!device ||!device.sharedAttributes == null || !showSharedAttributes) return null;
    return(
        <div className="attributes-table-container">
            <table className="attributes-table">
                <thead>
                    <tr id="attributes-table-header-row">
                        <th>Last update date</th>
                        <th>Last update time</th>
                        <th>Key</th>
                        <th>Value</th>
                    </tr>
                </thead>
                <tbody>
                    {device.sharedAttributes.map(sharedAttribute => (
                        <tr key={sharedAttribute.key}>
                            <td>{LoadShortDate(sharedAttribute.lastUpdateTs)}</td>
                            <td>{LoadShortTime(sharedAttribute.lastUpdateTs)}</td>
                            <td>{sharedAttribute.key}</td>
                            <td>{getSharedAttributValue(sharedAttribute)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
const ClientAttributes = ({device,showClientAttributes}) =>{
    function getClientAttributValue(clientAttribute){
        switch(clientAttribute.value){
            case true: return 'true';
            case false: return 'false';
            default: return clientAttribute.value;
        }
    }
    if(!device ||!device.clientAttributes == null || !showClientAttributes) return null;
    return(
        <div className="attributes-table-container">
            <table className="attributes-table">
                <thead>
                    <tr id="attributes-table-header-row">
                        <th>Last update date</th>
                        <th>Last update time</th>
                        <th>Key</th>
                        <th>Value</th>
                    </tr>
                </thead>
                <tbody>
                    {device.clientAttributes.map(clientAttribute => (
                        <tr key={clientAttribute.key}>
                            <td>{LoadShortDate(clientAttribute.lastUpdateTs)}</td>
                            <td>{LoadShortTime(clientAttribute.lastUpdateTs)}</td>
                            <td>{clientAttribute.key}</td>
                            <td>{getClientAttributValue(clientAttribute)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
const Attributes = ({device,showAttributes}) =>{
    const [showServerAttributes,setShowServerAttributes] = useState(true);
    const [showSharedAttributes,setShowSharedAttributes] = useState(false);
    const [showClientAttributes,setShowClientAttributes] = useState(false);
    const [selectedAttributes,setSelectedAttributes] = useState("Server attributes");
    function displayServerAttributes(){
        setShowSharedAttributes(false);
        setShowClientAttributes(false);
        setShowServerAttributes(true);
    }
    function displaySharedAttributes(){
        setShowServerAttributes(false);
        setShowClientAttributes(false);
        setShowSharedAttributes(true);
    }
    function displayClientAttributes(){
        setShowServerAttributes(false);
        setShowSharedAttributes(false);
        setShowClientAttributes(true);
    }
    if(!device || !showAttributes) return null;
    return(
        <div className="attributes-container">
            <div className="attributes-header">
                <p>{selectedAttributes}</p>
                <div className="attributes-select-container">
                    <p>Attributes scope</p>
                    <select
                        onChange={(e) => {
                            switch(e.target.value){
                                case "server":
                                    displayServerAttributes();
                                    setSelectedAttributes("Server attributes");
                                    break;
                                case "shared":
                                    displaySharedAttributes();
                                    setSelectedAttributes("Shared attributes");
                                    break;
                                case "client":
                                    displayClientAttributes();
                                    setSelectedAttributes("Client attributes");
                                    break;
                            }
                        }}
                    >
                        <option value="server">Server attributes</option>
                        <option value="shared">Shared attributes</option>
                        <option value="client">Client attributes</option>
                    </select>
                </div>
            </div>
            <div>
                <ServerAttributes device={device} showServerAttributes={showServerAttributes} />
                <SharedAttributes device={device} showSharedAttributes={showSharedAttributes} />
                <ClientAttributes device={device} showClientAttributes={showClientAttributes} />
            </div>
        </div>
    );
}
const LatestTelemetry =({device,showLatestTelemetry}) =>{
    if(!device || !showLatestTelemetry) return null;
    return(
        <div className="latest-telemetry-container">
            <div className="latest-telemetry-header">
                <h5>Telemetry</h5>
            </div>
            <div className="latest-telemetry-table-container">
                <table className="latest-telemetry-table">
                    <thead>
                        <tr id="latest-telemetry-table-header">
                            <th>Last update date</th>
                            <th>Last update time</th>
                            <th>Key</th>
                            <th>Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        {device.latestTelemetry.map((latestTelemetry,index) =>(
                            <tr key={index}>
                                <td>{LoadShortDate(latestTelemetry.timeStamp)}</td>
                                <td>{LoadShortTime(latestTelemetry.timeStamp)}</td>
                                <td>{latestTelemetry.key}</td>
                                <td>{latestTelemetry.value.toString()}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
const DeviceConfiguration = ({
    device,
    deviceRef,
    accessToken,
    showDeviceConfiguration,
    showConfigurationExplorer,
    setShowConfigurationExplorer,
    showNewConfiguration,
    setShowNewConfiguration,
    showImportConfiguration,
    setShowImportConfiguration}) =>{
    const {selectedTenantAdminProfile} = useContext(DeviceContext);
    const [editMode,setEditMode] = useState(false);
    const [selectedConfigurationTemplate,setSelectedConfigurationTemplate] = useState(null);
    const [deviceConfiguration,setDeviceConfiguration] = useState(null);
    const [tempUpdatingConfiguration,setTempUpdatingConfiguration] = useState(null);
    const [showConfirmUpdateDialog,setShowConfirmUpdateDialog] = useState(false);
    const [deviceConfigurationYesNoMessageBoxTitle,setDeviceConfigurationYesNoMessageBoxTitle] = useState('Confirm');
    const [deviceConfigurationYesNoMessageBoxQuestion,setDeviceConfigurationYesNoMessageBoxQuestion] = useState('Confirm?');
    const [deviceConfigurationYesNoMessageBoxDialogResult,setDeviceConfigurationYesNoMessageBoxDialogResult] = useState(null);
    const [showDeviceConfigurationMessageBox,setShowDeviceConfigurationMessageBox] = useState(false);
    const [deviceConfigurationMessageBoxTitle,setDeviceConfigurationMessageBoxTitle] = useState('Title');
    const [deviceConfigurationMessageBoxMessage,setDeviceConfigurationMessageBoxMessage] = useState('Message');
    const updatingDeviceConfigurationStatus = useRef('');
    const updateDeviceConfiguration = async() =>{
        try{
            updatingDeviceConfigurationStatus.current = 'updating';
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/devices/${deviceRef?.id}/configuration`;
            let updatingConfiguration = {};
            updatingConfiguration.attributesType = tempUpdatingConfiguration.attributes !== undefined? tempUpdatingConfiguration.attributes:tempUpdatingConfiguration.attributesType;
            updatingConfiguration.details = tempUpdatingConfiguration.details.reduce((acc,detail) => {
                acc[detail.parameter] = detail.defaultValue !== undefined? detail.defaultValue:detail.value;
                return acc;
            },{});
            const response = await fetch(url,{
                method:'PUT',
                headers:{
                    'Authorization':`Bearer ${accessToken}`,
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(updatingConfiguration)
            });
            if(response.ok) updatingDeviceConfigurationStatus.current = 'updated';
            else updatingDeviceConfigurationStatus.current = 'failed';
        }
        catch(error){
            console.error(error);
            updatingDeviceConfigurationStatus.current = 'failed';
        }
        setDeviceConfiguration(null);
    };
    useEffect(() =>{
        if(updatingDeviceConfigurationStatus.current === 'failed'){
            updatingDeviceConfigurationStatus.current = '';
            showMessageBox('Update failed','An error occurred when updating device configuration');
        }
    },[updatingDeviceConfigurationStatus]);
    useEffect(() =>{
        if(deviceConfiguration || !device?.configuration || device?.configuration === null) return;
        if(JSON.stringify(deviceConfiguration) !== JSON.stringify(deviceRef?.configuration)) setDeviceConfiguration(device?.configuration);
    },[device]);
    useEffect(() =>{
        if(!deviceConfiguration || deviceConfiguration === null || !device?.configuration || device?.configuration === null) return;//This is for updating only NOT INITIALIZING.
        if(JSON.stringify(deviceConfiguration) !== JSON.stringify(deviceRef?.configuration)) setDeviceConfiguration(device?.configuration);
    },[device]);
    useEffect(() =>{
        if(updatingDeviceConfigurationStatus.current !== 'failed') return;
        if(deviceConfiguration !== null || !device?.configuration || device?.configuration === null) return;//This is for updating only when failed.
        setDeviceConfiguration(device?.configuration);
    },[deviceConfiguration]);
    useEffect(() =>{
        if(deviceConfiguration === null) return;
        if(updatingDeviceConfigurationStatus.current === 'updated') showMessageBox('Update successful','Device configuration updated successfully');
        else if(updatingDeviceConfigurationStatus.current === 'failed') showMessageBox('Update failed','An error occurred when updating device configuration');
        if(updatingDeviceConfigurationStatus.current !== '') updatingDeviceConfigurationStatus.current = '';
    },[deviceConfiguration]);
    useEffect(() =>{
        setTempUpdatingConfiguration(selectedConfigurationTemplate !== null? JSON.parse(JSON.stringify(selectedConfigurationTemplate)):JSON.parse(JSON.stringify(deviceConfiguration)));
    },[selectedConfigurationTemplate,deviceConfiguration]);
    useEffect(() =>{
        if(!showConfirmUpdateDialog){
            setSelectedConfigurationTemplate(null);
            setDeviceConfigurationYesNoMessageBoxDialogResult(null);
            setTempUpdatingConfiguration(JSON.parse(JSON.stringify(deviceConfiguration)));
            setEditMode(false);
        }
    },[showConfirmUpdateDialog]);
    useEffect(() =>{
        async function handleConfirmUpateResult(){
            if(deviceConfigurationYesNoMessageBoxDialogResult && deviceConfigurationYesNoMessageBoxDialogResult === true){
                await updateDeviceConfiguration();
                setTempUpdatingConfiguration(JSON.parse(JSON.stringify(deviceConfiguration)));
                setDeviceConfigurationYesNoMessageBoxDialogResult(null);
            }
            else setTempUpdatingConfiguration(deviceConfiguration);
        }
        handleConfirmUpateResult();
    },[deviceConfigurationYesNoMessageBoxDialogResult]);
    const showMessageBox = (title,message) =>{
        setDeviceConfigurationMessageBoxTitle(title);
        setDeviceConfigurationMessageBoxMessage(message);
        setShowDeviceConfigurationMessageBox(true);
    };
    if(!deviceRef || !showDeviceConfiguration) return null;
    return(
        <div className="device-configuration-container">
            <div className="device-configuration-header">
                <div>
                    <h5>Configuration</h5>
                </div>
                <div>
                    <button
                        className="edit-device-configuration-button"
                        style={{display:`${editMode? 'none':'inline-block'}`}}
                        onClick={() => {
                            if(showConfigurationExplorer || showNewConfiguration || showConfirmUpdateDialog || showDeviceConfigurationMessageBox) return;
                            setEditMode(true)}
                        }>Edit</button>
                    <button
                        className="import-device-configuration-button"
                        style={{display:`${editMode? 'inline-block':'none'}`}}
                        onClick={() =>{
                            if(showConfigurationExplorer || showNewConfiguration || showConfirmUpdateDialog || showDeviceConfigurationMessageBox) return;
                            setShowImportConfiguration(true);
                        }}>Import</button>
                    <button
                        className="device-configuration-explorer-button"
                        style={{display:`${editMode? 'inline-block':'none'}`}}
                        onClick={() => {
                            if(showConfigurationExplorer || showNewConfiguration || showConfirmUpdateDialog || showDeviceConfigurationMessageBox) return;
                            setShowConfigurationExplorer(true)
                        }}>Explorer</button>
                </div>
            </div>
            <div>
                {updatingDeviceConfigurationStatus.current !== ''?
                    (
                        <div className="tenant-admin-updating-device-configuration-progress-container">
                            <div className="tenant-admin-updating-device-configuration-progress-spinner"></div>
                            <div>
                                <p>Updating device configuration</p>
                                <p>Please wait...</p>
                            </div>
                        </div>
                    ):
                    selectedConfigurationTemplate || (deviceConfiguration && deviceConfiguration.details && deviceConfiguration.details.length > 0)?
                    (<table className="device-configuration-table">
                        <thead>
                            <tr id="device-configuration-table-header-row">
                                <th>Parameter</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tempUpdatingConfiguration && tempUpdatingConfiguration.details && 
                            [...tempUpdatingConfiguration.details]
                            .sort((a,b) => a?.parameter?.localeCompare(b?.parameter))
                            .map((detail,index) => (
                                    <tr key={index}>
                                        <td>{detail.parameter}</td>
                                        <td><input readOnly={!editMode} value={detail.defaultValue? detail.defaultValue: detail.value || ''} onChange={(e) =>{
                                            const updatedDetails = tempUpdatingConfiguration.details.map(d =>
                                                d?.parameter === detail?.parameter?
                                                {...d,defaultValue: d?.defaultValue !== undefined? e.target.value : d.value = e.target.value}:d
                                            );
                                            setTempUpdatingConfiguration({
                                                ...tempUpdatingConfiguration,
                                                details: updatedDetails,
                                            });
                                        }}/></td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>):
                    (
                        <div className="device-configuration-no-config-container">
                            <h4>Device has no configuration</h4>
                            <p>This device currently has no configuration. To set it up, import a configuration template and modify it to suit the device's needs. If you need to create a new template, use the
                                <span 
                                    style={{color:'blue',cursor:'pointer'}}
                                    onClick={() =>{
                                        setEditMode(true);
                                        setShowConfigurationExplorer(true);}}> Configuration Explorer window</span>.
                            </p>
                        </div>
                    )
                }
            </div>
            <div
                className="device-configuration-buttons-container"
                style={{marginTop:`${(selectedConfigurationTemplate || (deviceConfiguration && deviceConfiguration.length > 0)? '20px':'40px')}`}}>
                <div>
                    <button
                        style={{display:`${editMode? 'block':'none'}`}}
                        onClick={() => {
                            if(showConfigurationExplorer || showNewConfiguration || showConfirmUpdateDialog || showDeviceConfigurationMessageBox) return;
                            setSelectedConfigurationTemplate(null);
                            setTempUpdatingConfiguration(JSON.parse(JSON.stringify(deviceConfiguration)));
                            setEditMode(false);
                        }}>Cancel
                    </button>
                    <button
                        style={{display:`${editMode && tempUpdatingConfiguration? 'block':'none'}`}}
                        onClick={async() =>{
                            if(showConfigurationExplorer || showNewConfiguration || showConfirmUpdateDialog || showDeviceConfigurationMessageBox) return;
                            setDeviceConfigurationYesNoMessageBoxTitle('Confirm configuration update');
                            setDeviceConfigurationYesNoMessageBoxQuestion('Update device configuration? This action cannot be reversed');
                            setShowConfirmUpdateDialog(true);
                        }}>Update
                    </button>
                </div>
            </div>
            <ConfigurationExplorer
                accessToken={accessToken}
                showConfigurationExplorer={showConfigurationExplorer}
                setShowConfigurationExplorer={setShowConfigurationExplorer}
                showNewConfiguration={showNewConfiguration}
                setShowNewConfiguration={setShowNewConfiguration}
            />
            <NewConfiguration
                accessToken={accessToken}
                showNewConfiguration={showNewConfiguration}
                setShowNewConfiguration={setShowNewConfiguration}
            />
            <ImportConfiguration
                accessToken={accessToken}
                selectedConfigurationTemplate={selectedConfigurationTemplate}
                setSelectedConfigurationTemplate={setSelectedConfigurationTemplate}
                showImportConfiguration={showImportConfiguration}
                setShowImportConfiguration={setShowImportConfiguration}
            />
            <DeviceConfigurationYesNoMessageBox
                showDeviceConfigurationYesNoMessageBox={showConfirmUpdateDialog}
                setShowDeviceConfigurationMessageBox={setShowConfirmUpdateDialog}
                title={deviceConfigurationYesNoMessageBoxTitle}
                question={deviceConfigurationYesNoMessageBoxQuestion}
                setDialogResult={setDeviceConfigurationYesNoMessageBoxDialogResult}
            />
            <DeviceConfigurationMessageBox
                showDeviceConfigurationMessageBox={showDeviceConfigurationMessageBox}
                setShowDeviceConfigurationMessageBox={setShowDeviceConfigurationMessageBox}
                title={deviceConfigurationMessageBoxTitle}
                message={deviceConfigurationMessageBoxMessage}
            />
        </div>
    );
}
const Device = ({deviceId,deviceIdRef,setDeviceId,selectedServerUrl,access_token,showDeviceComponent,setShowDeviceComponent,logout,setShowBottomRightMessageBox,setBottomRightMessageBoxMessage}) =>{
    const {selectedTenantAdminProfile,selectedDevice,setSelectedDevice} = useContext(DeviceContext);
    const [showDeviceDetails,setShowDeviceDetails] = useState(true);
    const [showAttributes,setShowAttributes] = useState(false);
    const [showLatestTelemetry,setShowLatestTelemetry] = useState(false);
    const [showDeviceConfiguration,setShowDeviceConfiguration] = useState(false);
    const [showBillingDetails,setShowBillingDetails] = useState(false);
    const [detailsNavigationButtonHovered,setDetailsNavigationButtonHovered] = useState(false);
    const [attributesNavigationButtonHovered,setAttributesNavigationButtonHovered] = useState(false);
    const [latestTelemetryNavigationButtonHovered,setLatestTelemetryNavigationButtonHovered] = useState(false);
    const [deviceConfigurationNavigationButtonHovered,setDeviceConfigurationButtonHovered] = useState(false);
    const [showConfigurationExplorer,setShowConfigurationExplorer] = useState(false);
    const [showNewConfiguration,setShowNewConfiguration] = useState(false);
    const [showImportConfiguration,setShowImportConfiguration] = useState(false);
    const deviceRef = useRef(selectedDevice);
    const showDeviceComponentRef = useRef(showDeviceComponent);
    async function fetchDeviceById(){
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/devices/${deviceIdRef !== null && deviceIdRef.current !== null? deviceIdRef.current:deviceId}`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                const responseData = await response.json();
                if(!deviceRef.current || JSON.stringify(responseData) !== JSON.stringify(deviceRef.current)){
                    setSelectedDevice(responseData);
                }
            }
            else if(Number(response.status) === 401) logout();
            else throw new Error(`response code: ${response.status}`);
        }
        catch(error){
            console.error(error);
        }
    };
    useEffect(() => {
        deviceRef.current = selectedDevice;
    },[selectedDevice]);
    useEffect(() =>{
        showDeviceComponentRef.current = showDeviceComponent;
    },[showDeviceComponent]);
    useEffect(() =>{
        if(deviceIdRef === null || !deviceId || !showDeviceComponent) return;
        let fetchDeviceByIdRepeatedlyId;
        const fetchDeviceByIdRepeatedly = async () =>{
            clearTimeout(fetchDeviceByIdRepeatedlyId);
            await fetchDeviceById();
            if(showDeviceComponentRef.current){
                fetchDeviceByIdRepeatedlyId = setTimeout(fetchDeviceByIdRepeatedly,2000);
            }
        }
        fetchDeviceByIdRepeatedly();
        return () => {
            clearTimeout(fetchDeviceByIdRepeatedlyId);
        }
    },[deviceId,showDeviceComponent]);
    function displayDetails(){
        setShowAttributes(false);
        setShowLatestTelemetry(false);
        setShowDeviceConfiguration(false);
        setShowBillingDetails(false);
        setShowDeviceDetails(true);
    }
    function displayAttributes(){
        setShowDeviceDetails(false);
        setShowLatestTelemetry(false);
        setShowDeviceConfiguration(false);
        setShowBillingDetails(false);
        setShowAttributes(true);
    }
    function displayLatestTelemetry(){
        setShowDeviceDetails(false);
        setShowAttributes(false);
        setShowDeviceConfiguration(false);
        setShowBillingDetails(false);
        setShowLatestTelemetry(true);
    }
    function displayDeviceConfiguration(){
        setShowDeviceDetails(false);
        setShowAttributes(false);
        setShowLatestTelemetry(false);
        setShowBillingDetails(false);
        setShowDeviceConfiguration(true);
    }
    function displayBillingDetails(){
        setShowDeviceDetails(false);
        setShowAttributes(false);
        setShowLatestTelemetry(false);
        setShowDeviceConfiguration(false);
        setShowBillingDetails(true);
    }
    if(!deviceIdRef || !showDeviceComponent) return null;
    return(
        <div className="device-container">
            <div className="device-container-header">
                <div>
                    <h3>{`${selectedDevice? selectedDevice.name:'Loading...'}`}</h3>
                    <h4>Device details</h4>
                </div>
                <div>
                    <p onClick={() =>{
                        if(showConfigurationExplorer || showNewConfiguration) return;
                        setDeviceId(null);
                        setSelectedDevice(null);
                        displayDetails();
                        setShowDeviceComponent(false);
                    }}>&#10006;</p>
                </div>
            </div>
            <div className="device-container-navigation-bar">
                <div className="device-details-navigation-bar-button-container">
                    <button
                        onMouseEnter={() => setDetailsNavigationButtonHovered(true)}
                        onMouseLeave={() => setDetailsNavigationButtonHovered(false)}
                        style={{backgroundColor:showDeviceDetails? 'darkgray':detailsNavigationButtonHovered? 'lightgray':'transparent'}} 
                        onClick={() => displayDetails()}>Details
                    </button>
                </div>
                <div className="device-attributes-navigation-bar-button-container">
                    <button
                        onMouseEnter={() => setAttributesNavigationButtonHovered(true)}
                        onMouseLeave={() => setAttributesNavigationButtonHovered(false)}
                        style={{backgroundColor:showAttributes? 'darkgray':attributesNavigationButtonHovered? 'lightgray':'transparent'}}
                        onClick={() => displayAttributes()}>Attributes
                    </button>
                </div>
                <div className="device-latest-telemetry-navigation-bar-button-container">
                    <button
                        onMouseEnter={() => setLatestTelemetryNavigationButtonHovered(true)}
                        onMouseLeave={() => setLatestTelemetryNavigationButtonHovered(false)}
                        style={{backgroundColor:showLatestTelemetry? 'darkgray':latestTelemetryNavigationButtonHovered? 'lightgray':'transparent'}} 
                        onClick={() => displayLatestTelemetry()}>Latest telemetry
                    </button>
                </div>
                <div className="device-configuration-navigation-bar-button-container">
                    <button
                        onMouseEnter={() => setDeviceConfigurationButtonHovered(true)}
                        onMouseLeave={() => setDeviceConfigurationButtonHovered(false)}
                        onClick={() => displayDeviceConfiguration()}
                        style={{backgroundColor:showDeviceConfiguration? 'darkgray':deviceConfigurationNavigationButtonHovered? 'lightgray':'transparent'}}>Configuration
                    </button>
                </div>
                <div className="device-billing-navigation-bar-button-container">
                    <button
                        onClick={() => displayBillingDetails()}
                        style={{backgroundColor:showBillingDetails? 'darkgray':deviceConfigurationNavigationButtonHovered? 'lightgray':'transparent'}}
                    >Billing</button>
                </div>
            </div>
            <div className="device-container-body">
                <Details device={selectedDevice} showDeviceDetails={showDeviceDetails} setShowBottomRightMessageBox={setShowBottomRightMessageBox} setBottomRightMessageBoxMessage={setBottomRightMessageBoxMessage}/>
                <Attributes device={selectedDevice} showAttributes={showAttributes}/>
                <LatestTelemetry device={selectedDevice} showLatestTelemetry={showLatestTelemetry} />
                <DeviceConfiguration
                    device={selectedDevice}
                    deviceRef={deviceRef.current}
                    accessToken={access_token}
                    selectedServerUrl={selectedServerUrl}
                    showDeviceConfiguration={showDeviceConfiguration}
                    showConfigurationExplorer={showConfigurationExplorer}
                    setShowConfigurationExplorer={setShowConfigurationExplorer}
                    showNewConfiguration={showNewConfiguration}
                    setShowNewConfiguration={setShowNewConfiguration}
                    showImportConfiguration={showImportConfiguration}
                    setShowImportConfiguration={setShowImportConfiguration}
                />
                <BillingDetails showBillingDetails={showBillingDetails}/>
            </div>
        </div>
    );
};
export default Device;